import Vue from 'vue'
import App from './App.vue'
import { createAxiosInstance } from './AxiosInstance'  // Updated import
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import 'jquery'
import 'popper.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Toastification
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

// --- Register Toastification ---
Vue.use(Toast, {
  position: "top-right",    // top-right, top-left, bottom-right, bottom-left
  timeout: 5000,            // 5 seconds
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6
})

// Dynamically load config.json and initialize Axios
async function bootstrapApp() {
  try {
    const axiosInstance = await createAxiosInstance();
    Vue.prototype.$http = axiosInstance;

    Vue.config.productionTip = false;

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  } catch (error) {
    console.error('Failed to initialize app:', error);
  }
}

bootstrapApp();